import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {getValueArray} from '../../utils/array';
import _ from 'lodash';

import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';

import {
	Plugin, Getter, Template, TemplateConnector
} from '@devexpress/dx-react-core';

import {
	FilteringState,
	IntegratedFiltering, IntegratedPaging, IntegratedSelection, IntegratedSorting,
	PagingState, SelectionState, SortingState, DataTypeProvider
} from '@devexpress/dx-react-grid';

import {
	Grid, PagingPanel,
	Table, TableFilterRow,
	TableHeaderRow, TableSelection, TableColumnResizing
} from '@devexpress/dx-react-grid-material-ui';


const styles = {
	tableHeader: {
		'& thead tr':{
			height:'auto'
		},
		'& thead tr th' : {
			borderBottom:'none',
			textAlign: 'left !important',
			paddingTop:0,
			paddingBottom:0
		},
		'& thead tr:first-of-type th > div:last-child' : {
			height:'250%'
		},
		'& thead tr:last-of-type th': {
			borderBottom:'#039be5 solid 3px',
			paddingBottom: 15
		},
		'& thead tr th div > span' : {
			flexDirection: 'inherit !important',
			color:'#039be5 !important'
		},
		'& thead tr th:first-child':{
			paddingLeft:0
		},
		'& thead tr th:nth-last-of-type(2)':{
			paddingRight:0
		},
		'& thead tr:nth-of-type(2) th > div': {
			flexFlow:'row-reverse'
		},
		'& thead tr:nth-of-type(2) th > div button': {
			padding:'5px',
			zIndex:99
		},
		'& thead tr:nth-of-type(2) th > div button:disabled': {
			display:'none'
		},
		'& thead tr:nth-of-type(2) th > div button + div': {
			marginRight:'-30px',
			paddingRight:'30px'
		},
		'& thead tr:nth-of-type(2) th > div button:disabled + div': {
			display:'none'
		},
		'& thead tr:nth-of-type(2) th > div input': {
			fontSize:'80%',
			fontFamily:'inherit',
			paddingBottom : 4,
			height:'auto'
		},
		'& tbody tr td:first-child':{
			paddingLeft:0
		},
		'& tbody tr td:nth-last-of-type(2)':{
			paddingRight:0
		},

		'& tbody tr:hover td': {
			backgroundColor:'rgba(200,200,200,0.1)'
		},
		'& tbody tr.isHighLight td': {
			backgroundColor:'rgba(200,200,200,0.3)'
		},
		'& tbody tr.isHighLight2 td': {
			backgroundColor:'rgba(255,242,204,0.3)'
		},
		'& tbody tr.isDeleted td': {
			backgroundColor:'rgba(200,200,200,0.6)'
		},
		'& tbody tr td.isSelectionReplaceButton': {
			position:'relative',
			overflow:'visible',
		},
		'& tbody tr td.isSelectionReplaceButton button': {
			position:'absolute',
			top:8,
			left:-50,
			minWidth:'54px !important'
		},
		'& tbody tr td.bigFontColumn':{
			fontSize:'120%'
		}

	},
	numericInput: {
		textAlign: 'right',
		width: '100%',
		'&::-webkit-input-placeholder' :{
			textAlign: 'left'
		},
		'&:-moz-placeholder' : {
			textAlign: 'left'
		},
		'&::-moz-placeholder' : {
			textAlign: 'left'
		},
		'&:-ms-input-placeholder' : {
			textAlign: 'left'
		}

	}
};

const messages = {
	filterPlaceholder:"絞り込み",
	contains:"～を含む",
	notContains:"～を含まない",
	startsWith:"～から始まる",
	endsWith:"～で終わる",
	equal:"等しい",
	notEqual:"等しくない",
	greaterThan:"～より多い",
	greaterThanOrEqual:"以上",
	lessThan:"～より小さい",
	lessThanOrEqual:"以下",
};

const pageMessages = {
	rowsPerPage : "表示件数",
	info : "{from} - {to} 件 / {count} 件中"
};

const tableMessage = {
	noData : "データなし"
};

const TableComponentBase = ({ classes, ...restProps }) => (
	<Table.Table
		{...restProps}
		className={classes.tableHeader}
	/>
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(TableComponentBase);

const Row = ({ tableRow, onDoubleFunc, ...restProps }) => {
	const handleDoubleClick = () => {
		if(tableRow.row === undefined) return;
		if(onDoubleFunc) onDoubleFunc(tableRow.row);
	};

	let isHighLight = (tableRow.row !== undefined) ? (tableRow.row.isHighLight === "1") : false;
	let isHighLight2 = (tableRow.row !== undefined) ? (tableRow.row.isHighLight2 === "1") : false;
	if(isHighLight2) isHighLight = false;
	const isDeleted = (tableRow.row !== undefined) ? (tableRow.row.isDeleted === "1") : false;
	if(isDeleted) {
		isHighLight = false;
		isHighLight2 = false;
	}

	return (
		<Table.Row
			{...restProps}
			className={isDeleted ? 'isDeleted' : isHighLight2 ? 'isHighLight2' : isHighLight ? 'isHighLight' :''}
			onDoubleClick={handleDoubleClick}
		/>
	);
};

const NumberEditorBase = ({ value, onValueChange, classes }) => {
	const handleChange = (event) => {
		const { value: targetValue } = event.target;
		if (targetValue.trim() === '') {
			onValueChange();
			return;
		}
		onValueChange(parseInt(targetValue, 10));
	};
	return (
		<Input
			type="number"
			classes={{
				input: classes.numericInput,
			}}
			fullWidth
			value={value === undefined ? '' : value}
			inputProps={{
				min: 0,
				placeholder: '絞り込み',
			}}
			onChange={handleChange}
		/>
	);
};

NumberEditorBase.propTypes = {
	value: PropTypes.number,
	onValueChange: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

NumberEditorBase.defaultProps = {
	value: undefined,
};

const NumberEditor = withStyles(styles)(NumberEditorBase);


const getRowId = row => row.id;

const ClickableCell = ({func,row,props})  =>{

    const handleClickFunction = () =>{
        if(func) func(row);
    };
    return(
        <Table.Cell>
            <span
                onClick={handleClickFunction}
                style={{
                    cursor:'pointer',
                    color:'#039be5'
                }}
            >
                {props.value}
            </span>
        </Table.Cell>

    );
};

const ButtonCell = ({func,row,text,props})  =>{

	const handleClickFunction = () =>{
		if(func) func(row);
	};
	return(
		<Table.Cell>
			<Button variant="contained" size="small" onClick={handleClickFunction}>
				{text}
			</Button>
		</Table.Cell>

	);
};

const SelectionReplaceButtonCell = ({func,row,text,props})  =>{

	const handleClickFunction = () =>{
		if(func) func(row);
	};
	return(
		<Table.Cell
			className={'isSelectionReplaceButton'}
		>
			{row.isSelectionReplace === "1" &&
			<Button variant="contained" size="small" onClick={handleClickFunction}>
				{text}
			</Button>
			}
		</Table.Cell>

	);
};

const getColumnInfo = (columns) =>{
	return columns.map((row)=>{
		return {name:row.name, title:row.title}
	})
};
const getColumnWidth = (columns) =>{
	return columns.map((row)=>{
		return {columnName:row.name, width:row.width}
	})
};
const getColumnAlign = (columns) =>{
	return columns.map((row)=>{
		return {columnName:row.name, align:(row.align) ? row.align : 'left' }
	})
};

const getColumnFilterDisabled = (columns) =>{
	return columns.map((row)=>{
		return {columnName:row.name, filteringEnabled:(row.filteringEnabled !== undefined) ? row.filteringEnabled : true }
	})
};

const getColumnSortingDisabled = (columns) =>{
	return columns.map((row)=>{
		return {columnName:row.name, sortingEnabled:(row.sortingEnabled !== undefined) ? row.sortingEnabled : true }
	})
};


const Cell = (clickableColumns,props) => {

    const {column,row} = props;

    const index = _.findIndex(clickableColumns,{'name':column.name});
    if(index === -1){
    	return <Table.Cell className='bigFontColumn' {...props} />;


    }
    else{
    	if(clickableColumns[index].type === "button"){
			if(clickableColumns[index].name === "SelectionReplaceButton"){
				return <SelectionReplaceButtonCell props={props} func={clickableColumns[index].func} row={row} text={clickableColumns[index].text} />
			}
			else{
				return <ButtonCell props={props} func={clickableColumns[index].func} row={row} text={clickableColumns[index].text}/>
			}

		}
    	else{
			return <ClickableCell props={props} func={clickableColumns[index].func} row={row} />
		}

    }

};

const rowSelectionEnabled = row => !(row.isSelectionDisabled === "1");

class PatchedIntegratedSelection extends Component {
	render() {
		const { rowSelectionEnabled, ...restProps } = this.props;
		return (
			<Plugin>
				<Getter
					name="rows"
					computed={({ rows }) => {
						this.rows = rows;
						return rows.filter(rowSelectionEnabled);
					}}
				/>
				<IntegratedSelection {...restProps} />
				<Getter
					name="rows"
					computed={() => this.rows}
				/>
			</Plugin>
		)
	}
}

class PatchedTableSelection extends Component {
	render() {
		const { rowSelectionEnabled, ...restProps } = this.props;
		return (
			<TableSelection
				cellComponent={(props) => rowSelectionEnabled(props.tableRow.row) ? (
					<TableSelection.Cell {...props} />
				) : (
					<Table.StubCell {...props} />
				)}
				{...restProps}
			/>
		);
	}
}


class commonTable extends Component {
	constructor(props) {
		super(props);
		let orgData;
		if(props.hasSelections){
			orgData = _.filter(props.dataSource,(row)=>{
				return row.isSelectionDisabled !== "1"
			});
		}
		else{
			orgData = props.dataSource;
		}

		const selections = (props.isDefaultUnChecked) ? [] : props.selections.length ?  props.selections : orgData;
		const selectedRow = this.getSelectedIdFromSelectedRow(selections);
		this.state = {
			IsProcess : false,
			columns: getColumnInfo(props.columns),
			defaultColumnWidths: getColumnWidth(props.columns),
			tableColumnExtensions : getColumnAlign(props.columns),
			pageSizes: props.pageSizes,
			rows: props.dataSource,
			numberColumns: props.numberColumns,
			clickableColumns:props.clickableColumns,
			numberFilterOperations: props.numberFilterOperations,
			filters:props.filters,
			selections,
			selectedRow,
			sortColumns : props.defaultSortColumn,
			sortDirection : props.defaultSortDirection,
			filterEnables : getColumnFilterDisabled(props.columns),
			sortEnables : getColumnSortingDisabled(props.columns)
		};
		if(this.props.getSelections) this.props.getSelections(selections);
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.dataSource !== this.props.dataSource){
			let orgData;
			if(nextProps.hasSelections){
				orgData = _.filter(nextProps.dataSource,(row)=>{
					return row.isSelectionDisabled !== "1"
				});
			}
			else{
				orgData = nextProps.dataSource;
			}
			const selections = (nextProps.isDefaultUnChecked) ? [] : nextProps.selections.length ?  nextProps.selections : orgData;
			const selectedRow = this.getSelectedIdFromSelectedRow(selections);

			this.setState({
				rows: nextProps.dataSource,
				selections,
				selectedRow,
			});
			if(this.props.getSelections) this.props.getSelections(selections);
		}

	}

	handleChangeSelection = selectedRow => {
		const {dataSource,getSelections} = this.props;
		const {sortColumns,sortDirection} = this.state;
		const selections = dataSource.filter(
			row =>
				selectedRow.findIndex(selectId => selectId === getRowId(row)) !== -1
		);
		selections.sort((a, b) => {
			if (sortDirection === 'asc'){
				return (a[sortColumns] < b[sortColumns]) ? -1 : 1;
			}
			else{
				return (a[sortColumns] > b[sortColumns]) ? -1 : 1;
			}
		});
		this.setState({
			selectedRow
		,	selections
		});
		if(getSelections) getSelections(selections);
	};

	handleSortingChange = event => {

		const sortColumns = event[0].columnName;
		const sortDirection = event[0].direction;

		this.setState({
			sortColumns
		,	sortDirection
		});
		if(this.props.getSortOrders) this.props.getSortOrders(sortColumns,sortDirection);
		let selections = getValueArray(this.state.selections);
		selections.sort((a, b) => {
			if (sortDirection === 'asc'){
				return (a[sortColumns] < b[sortColumns]) ? -1 : 1;
			}
			else{
				return (a[sortColumns] > b[sortColumns]) ? -1 : 1;
			}
		});

		const selectedRow = this.getSelectedIdFromSelectedRow(selections);

		this.setState({
			selectedRow,
			selections
		});
		if(this.props.getSelections) this.props.getSelections(selections);

	};

	handleFilteringChange = events => {
		this.setState({
			filters:events
		});
		if(this.props.getFilters) this.props.getFilters(events);

		let selections = getValueArray(this.state.selections);
		if(selections.length === 0) return;
		events.forEach((event) =>{
			const {columnName,operation,value} = event;

			selections = _.filter(selections,(row)=>{
				const row_value = row[columnName];
				if(!row_value) return;
				switch(operation){
					case 'contains':
						return (row_value.indexOf(value) !== -1);
					case 'notContains':
						return (row_value.indexOf(value) === -1);
					case 'startsWith':
						return (row_value.startsWith(value));
					case 'endsWith':
						return (row_value.endsWith(value));
					case 'equal':
						return (row_value === value);
					case 'notEqual':
						return (row_value !== value);
					case 'greaterThan':
						return (row_value > value);
					case 'greaterThanOrEqual':
						return (row_value >= value);
					case 'lessThan':
						return (row_value < value);
					case 'lessThanOrEqual':
						return (row_value <= value);
					default:
						return;
				}
			});
		});
		const selectedRow = this.getSelectedIdFromSelectedRow(selections);
		this.setState({
			selectedRow,
			selections,
		});
		if(this.props.getSelections) this.props.getSelections(selections);

	};



	getSelectedIdFromSelectedRow(rows){
		if(rows.length === 0){
			return [];
		}
		return rows.map(row=>{return row.id});
	}


	render() {
		const {
			rows, columns, defaultColumnWidths, pageSizes,
			numberColumns, numberFilterOperations,
			selectedRow, clickableColumns, tableColumnExtensions,
			filters,sortEnables,filterEnables
		} = this.state;
		const totalCount = rows.length;
		const selectedCount = selectedRow.length;

		return(
			<div>
				{this.props.isShowTotalCount &&
				<dl className="table_counts">
					<dt>合計件数</dt>
					<dd>{totalCount}件</dd>
				</dl>
				}
				{this.props.hasSelections && this.props.isShowSlectionCount &&
				<dl className="table_counts">
					<dt>チェック件数</dt>
					<dd>{selectedCount}件</dd>
				</dl>
				}
				{this.props.additionalCountContent &&
				<dl className="table_counts">
					<dt>{this.props.additionalCountContent.text}</dt>
					<dd>{this.props.additionalCountContent.count}件</dd>
				</dl>

				}
				<Grid
					rows={rows}
					columns={columns}
					getRowId={getRowId}
				>
					<DataTypeProvider
						for={numberColumns}
						availableFilterOperations={numberFilterOperations}
						editorComponent={NumberEditor}
					/>


					<FilteringState
						filters={filters}
						onFiltersChange = {this.handleFilteringChange}
						columnExtensions={[
							{columnName:'SelectionReplaceButton',filteringEnabled:false},
							...filterEnables
						]}
					/>
					<SortingState
						defaultSorting={[
							{ columnName: this.props.defaultSortColumn, direction: this.props.defaultSortDirection }
						]}
						onSortingChange={this.handleSortingChange}
						columnExtensions={[
							{columnName:'SelectionReplaceButton',sortingEnabled:false},
							...sortEnables
						]}
					/>
					{this.props.hasSelections &&
					<SelectionState
						selection={selectedRow}
						onSelectionChange={this.handleChangeSelection}
					/>
					}

					<PagingState
						defaultPageSize={pageSizes[0]}
					/>

					<IntegratedFiltering />
					<IntegratedSorting/>

					{this.props.hasSelections &&
					<PatchedIntegratedSelection
						rowSelectionEnabled={rowSelectionEnabled}
					/>
					}
					<IntegratedPaging />

					<Table
						tableComponent={TableComponent}
						rowComponent={Row}
						cellComponent={(props)=>Cell(clickableColumns,props)}
						messages={tableMessage}
						columnExtensions={tableColumnExtensions}
					/>
					<TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
					{this.props.hasSelections &&
					<PatchedTableSelection
						showSelectAll={true}
						rowSelectionEnabled={rowSelectionEnabled}
					/>
					}
					<TableHeaderRow showSortingControls={true} />
					<TableFilterRow
						showFilterSelector={true}
						messages={messages}
					/>
					<PagingPanel
						pageSizes={pageSizes}
						messages={pageMessages}
					/>
					<Template
						name="tableRow"
					>
						{params => (
							<TemplateConnector>
								{() => (
									<Row
										{...params}
										onDoubleFunc={this.props.doubleClickFunc}
									/>
								)}
							</TemplateConnector>
						)}
					</Template>
				</Grid>
			</div>
		);
	}
}
commonTable.propTypes = {
	dataSource: PropTypes.array,
	columns : PropTypes.array,
	selections : PropTypes.array,
	filters : PropTypes.array,
	defaultSortColumn : PropTypes.string,
	defaultSortDirection : PropTypes.string,
	numberColumns:  PropTypes.array,
	clickableColumns: PropTypes.array,
	hasSelections : PropTypes.bool,
	pageSizes : PropTypes.array,
	numberFilterOperations : PropTypes.array,
	doubleClickFunc : PropTypes.func,
	getSelections : PropTypes.func,
	getSortOrders : PropTypes.func,
	getFilters : PropTypes.func,
	isShowTotalCount : PropTypes.bool,
	isShowSlectionCount : PropTypes.bool,
	additionalCountContent : PropTypes.object,
	isDefaultUnChecked : PropTypes.bool

};
commonTable.defaultProps = {
	dataSource: [],
	columns: [],
	selections: [],
	filters: [],
	defaultSortDirection : 'asc',
	numberColumns: [],
	clickableColumns: [],
	hasSelections : true,
	pageSizes: [10, 20, 50],
	numberFilterOperations: ['equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'],
	isShowTotalCount : true,
	isShowSlectionCount : true,
	isDefaultUnChecked : false


};
export default commonTable;


// WEBPACK FOOTER //
// ./src/common/components/table/common-table.js